import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import DetailsInfoRow from '../DetailsInfoRow';

const propTypes = {
  permissions: PropTypes.shape({
    canSeeProvider: PropTypes.bool.isRequired,
  }).isRequired,
  provider: PropTypes.object,
  isClosed: PropTypes.bool,
  assignedToGroup: PropTypes.bool,
  providerGroupSpecialty: PropTypes.object,
};

const defaultProps = {
  provider: undefined,
  isClosed: false,
  assignedToGroup: false,
  providerGroupSpecialty: null,
};

const ProviderInfoRow = ({
  provider,
  permissions,
  assignedToGroup,
  providerGroupSpecialty,
  isClosed,
}) => {
  const groupSpecialtyDescription = assignedToGroup
    ? (
      <FormattedMessage
        id="General.ProvidersGroup"
        defaultMessage="** Providers group"
      />
    )
    : (
      <span>
        <span> { providerGroupSpecialty?.name } &nbsp;</span>
        <FormattedMessage
          id="SpecialtyGroup.SelectionListView"
          defaultMessage="** specialty group"
        />
      </span>
    );
  return (
    <Choose>
      <When condition={ assignedToGroup || providerGroupSpecialty }>
        <DetailsInfoRow
          withBorder
          isMasked={ !permissions.canSeeProvider }
          isDisabled={ isClosed }
          iconName={ assignedToGroup ? 'connected_dots' : 'connected_dots_topv' }
          title={
            <FormattedMessage
              id="Appointment.View.Details.Provider.Title"
              defaultMessage="** Provider"
            />
          }
          description={ (
            groupSpecialtyDescription
          ) }
        />
      </When>
      <Otherwise>
        <DetailsInfoRow
          withBorder
          iconName="stethoscope"
          isMasked={ !permissions.canSeeProvider }
          isDisabled={ isClosed }
          initials={ provider.initials }
          avatar={ provider.avatar }
          title={
            <FormattedMessage
              id="Appointment.View.Details.Provider.Title"
              defaultMessage="** Provider"
            />
          }
          description={ provider.name }
          availability={ provider.availability }
        />
      </Otherwise>
    </Choose>
  );
};

ProviderInfoRow.propTypes = propTypes;
ProviderInfoRow.defaultProps = defaultProps;

export default ProviderInfoRow;
